// @ts-check
import React, { useState } from 'react';
import Button from '@liquidweb-dev/undercurrent/Button';
import Menu, { menuClasses } from '@liquidweb-dev/undercurrent/Menu';
import { dividerClasses } from '@liquidweb-dev/undercurrent/Divider';
import pseudoClasses from '@liquidweb-dev/undercurrent/classes/pseudo';
import ChevronIcon from '@liquidweb-dev/undercurrent/icons/animated/Chevron';
import { IntroTarget, introTargets } from 'containers/introjs';
import { createMenuContent } from '../common/CreateMenuContent';
import useLeftHandLayout from '../context';

export function TopNavCreate() {
	const [menuElement, setMenuElement] = useState(
		/** @type {HTMLElement|undefined} */ (undefined),
	);
	const open = menuElement !== undefined;
	const { roles } = useLeftHandLayout();

	if (!roles.loggedIn) {
		return null;
	}

	return (
		<>
			<IntroTarget introId={introTargets.navDesktopCreateAndDeploy}>
				<Button
					color="highlight"
					variant={open ? 'primary' : 'secondary'}
					endIcon={<ChevronIcon open={open} />}
					onClick={({ currentTarget }) => setMenuElement(currentTarget)}
				>
					Create and deploy
				</Button>
			</IntroTarget>
			<Menu
				open={open}
				anchorEl={menuElement}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				onClose={() => setMenuElement(undefined)}
				sx={{
					[`& .${menuClasses.list}`]: {
						minWidth: '280px',
						display: 'flex',
						flexDirection: 'column',
						gap: 100,
						padding: 100,
					},
					[`& .${menuClasses.list}${pseudoClasses.important}`]: {
						padding: 100,
					},
					[`& .${menuClasses.list} .${dividerClasses.root}${pseudoClasses.important}`]:
						{
							marginX: -100,
							marginY: 0,
						},
					// After divider
					[`& .${menuClasses.list} .${dividerClasses.root} ~ *`]: {
						margin: -100,
						paddingX: 300,
						paddingY: 200,
						borderRadius: 0,
					},
				}}
			>
				{createMenuContent({ onClose: () => setMenuElement(undefined) })}
			</Menu>
		</>
	);
}

export default TopNavCreate;
